// importation des bibliothèques de modules node
import React, { useEffect, useState } from 'react';
import { Button, Card, Form } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';

// importation du profil layout wrapper
import materielProfileLayout from './DepenserecetteProfileLayout';

import DepenserecetteService from '../../services/DepenserecetteService';

const DeleteDepenserecette = () => {
	const [depenserecette, setDepenserecette] = useState(null);
	const { id } = useParams();
	const navigate = useNavigate();

	useEffect(() => {
		Promise.all([DepenserecetteService.getDepenserecette(id)]).then(([depenserecetteData]) => {
			setDepenserecette(depenserecetteData.data);
		});
	}, [id]);

	const handleSubmit = async (event) => {
		event.preventDefault();
		try {
			// Call the DepenserecetteService to delete the Depenserecette
			await DepenserecetteService.deleteDepenserecette(id);

			// Redirect the user to the list of Depenserecettes
			navigate('/finances/bilan');
		} catch (error) {
			console.error(
				"Erreur lors de la suppression du Bilan ",
				error
			);
		}
	};

	return (
		<materielProfileLayout>
			{depenserecette && (
				<>
					{/*  Form  */}
					<Form className="mb-3" onSubmit={handleSubmit}>
						<Card className="border-0">
							<Card.Header>
								<div className="mb-3 mb-lg-0">
									<h3 className="mb-0">
										Supprimer{' '}
										<span className="text-uppercase">{depenserecette.nom || ''}</span>
									</h3>
									<p className="mb-0">
										Supprimez définitivement ce Bilan.
									</p>
								</div>
							</Card.Header>
							<Card.Body>
								<span className="text-danger h4">Attention</span>
								<p>
									Si vous supprimez le ce Bilan, toutes les données le concernant seront
									définitivement perdues.
								</p>
								<Button variant="danger" type="submit">
									Supprimer le materiel
								</Button>
							</Card.Body>
						</Card>
					</Form>
				</>
			)}
		</materielProfileLayout>
	);
};

export default DeleteDepenserecette;
